import * as React from 'react';
import get from 'lodash/get';
import { inject, observer } from 'mobx-react';
import { replacePlaceholders } from '../utils/replacePlaceholders';
import { TranslationStore } from '../stores';

// TODO: Is it possible to inject translationStore as with the React component?
// export const translate = inject('translationStore')(({ translationStore }) => text => get(translationStore, text, text));

export const translate = (
    translationStore: TranslationStore,
    text: any,
    placeholders?: any
) => {
    const translationList = translationStore.translations;
    const translation = get(translationList, text, text);
    return placeholders
        ? replacePlaceholders({
              values: placeholders,
              text: translation,
          })
        : translation;
};

// Component to get translated text from translation dictionary
// Children should be a string, but any other child types, e.g. a component, will simply pass through
@inject('translationStore', 'dataStore')
@observer
class Translate extends React.Component<any, any> {
    render() {
        const {
            dataStore,
            translationStore,
            placeholders,
            children = null,
        } = this.props;
        if (
            dataStore &&
            dataStore.config &&
            dataStore.config.useHtmlTranslations
        ) {
            return (
                <span
                    dangerouslySetInnerHTML={{
                        __html: translate(
                            translationStore,
                            children,
                            placeholders
                        ),
                    }}
                />
            );
        }
        return translate(translationStore, children, placeholders);
    }
}

export default Translate;



// WEBPACK FOOTER //
// ./src/Components/Translate.tsx